import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";


import CollectionService from "../services/collection.service";


const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};

export const getCollections = createAsyncThunk(
  "auth/get_collections",
  async ({search}, thunkAPI) => {
    try {
      const data = await CollectionService.getCollections(search);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getCollection = createAsyncThunk(
  "auth/get_collection",
  async ({id}, thunkAPI) => {
    try {
      const data = await CollectionService.getCollection(id);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateCollection = createAsyncThunk(
  "auth/updateCollection",
  async ( {collection},thunkAPI) => {
    try {
      const data = await CollectionService.updateCollection(collection);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = { data: list, loading: false};

const collectionSlice = createSlice({
  name: "collection",
  initialState,
  extraReducers: {

    [getCollections.pending]: (state, action) => {
      state.loading = true;
    },
    [getCollections.fulfilled]: (state, action) => {
      state.data = action.payload.data; 
      state.loading = false;
    },
    [getCollections.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },

    [getCollection.pending]: (state, action) => {
      state.loading = true;
    },
    [getCollection.fulfilled]: (state, action) => {

      state.data.list.push(action.payload.data)
      state.data.total ++;

      state.loading = false;
    },
    [getCollection.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },
    
    [updateCollection.fulfilled]: (state, action) => {

      let collections = state.data.list;
      let thisCollection = collections.find((collection) => collection.id === action.payload.data.id)

      thisCollection.name = action.payload.data.name
      thisCollection.description = action.payload.data.description
      thisCollection.parentCollection = action.payload.data.parentCollection
      thisCollection.administrator = action.payload.data.administrator

    },


  },
});


const { reducer } = collectionSlice;
export default reducer;